import {debounce, redirectIfConflict} from '../common/tink';
import {determineLanguage} from '../common/util';
import {addPlaceholderToSelect} from "../form/form";
import {getTraduction, traductionEnum} from "../common/traduction";

/**
 * To call the Canada Post API we need the postal code to reduce the number of results.
 * If the results variable is already set we don't call Canada Post anymore (to limit the number of call to this expensive API) but just show the results for the input field. Else call the API and show results.
 */
export const CANADA_POST = {
    addressSelector: "input[data-address-auto-complete=true]",
    postalCodeSelector: "input[type=text][id^=postalCode][data-auto-complete-active=true]",
    results: [],

    initCompleteSearch: function (input) {
        var inputField = $(input);
        var searchTerm = inputField.val();
        if (searchTerm && typeof canadaPostAjaxUrl !== "undefined") {
            if (CANADA_POST.results[searchTerm] == null) {
                CANADA_POST.callSearchAddressCanadaPostApi(inputField, searchTerm);
            } else {
                CANADA_POST.showResults(inputField, searchTerm);
            }
        }
    },

    /**
     * Results are shown with the jquery autocomplete plugin.
     */
    showResults: function (input, postalCode) {
        if ($.contains(document, input[0])) { // T4286-6186 make sure the input has not been removed from DOM before displaying results
            var canadaPostAutocomplete = input.autocomplete({
                minLength: 0,
                source: CANADA_POST.results[postalCode],
                create: function (event, ui) {
                   input.attr({
                       'autocomplete': 'new-password',
                       'aria-owns': $('.ui-autocomplete').attr('id'),
                       'aria-autocomplete': 'list',
                       'role': 'combobox'
                   });
                },
                select: function (event, ui) {
                    var previousSearch = ui.item.previousSearch;
                    var isPrevious = typeof previousSearch !== 'undefined';
                    var isGroupOfAddresses = ui.item.groupOfAddresses;
                        if (isPrevious) {
                            input.autocomplete('destroy');
                            CANADA_POST.showResults(input, previousSearch);
                        } else if (isGroupOfAddresses) {
                            CANADA_POST.callSearchAddressForGroup(input, ui);
                        } else {
                            CANADA_POST.callRetrieveCanadaPostApi(input, ui);
                        }
                        return false;
                },
                focus: function (event, ui) {
                    if (!!event.currentTarget.querySelector('.ui-state-focus')) {
                        var optionActive = event.currentTarget.querySelector('.ui-state-focus').getAttribute('id');
                        input.attr('aria-activedescendant', optionActive);
                    } else {
                        input.attr('aria-activedescendant', '');
                    }
                },
                search: function (event) {
                    if (event.target.value === "") {
                        input.autocomplete('option', 'source', []);
                    }
                },
                messages: {
                    noResults: '',
                    results: function () {
                        // Just useful for accessibility
                        var messageResult = (determineLanguage() === 'fr') ? 'résultats disponibles. Utiliser les flèches du haut et du bas pour naviguer.' : 'results available, use up and down arrow keys to navigate.';
                        return `${CANADA_POST.results[postalCode].length} ${messageResult}`;
                    }
                },
            });

            // To open the autocomplete results when focus on the input field
            canadaPostAutocomplete.focus(function () {
                if ($(this).val() !== '') {
                    $(this).autocomplete("search");
                }
            });

            // To customise the dropdown addresses list
            canadaPostAutocomplete.autocomplete("instance")._renderItem = function (ul, item) {
                const arialabel = item.label + ' ' + item.description;
                $(ul).attr('aria-hidden', "true").attr('role', "listbox");
                return $('<li tabindex="-1" role="option">')
                    .append(typeof item.previousSearch !== 'undefined' ? '<span class="cp-collapsable"><img src="/images/shared/small/icons/next-gray.svg" alt="" /></span>' : '')
                    .attr('aria-label', arialabel)
                    .append("<span class='cp-address-description'> " + arialabel + "</span>")
                    .append(item.groupOfAddresses ? '<span class="cp-expandable"><img src="/images/next-gray.svg" alt="" /></span>' : '')
                    .appendTo(ul);
            };
            canadaPostAutocomplete.autocomplete("widget").addClass("canadapost-autocomplete");

            input.data("active", true);// To not recreate the autocomplete on the same input field
            //T4286-4016 : "" is added as second parameter otherwise autocomplete is not displayed if search term does not match
            input.autocomplete("search", "");// To open the autocomplete results when we get the results from canadapost
        }
    },

    callSearchAddressCanadaPostApi: function (input, searchTerm) {
        var sourceType = input.data("cp-source-type");
        var filterByPostalCode = input.data("filter-postal-code");
        var postalCode = filterByPostalCode ? input.data("postal-code") : undefined;
        $.ajax({
            url: canadaPostAjaxUrl + "/search/" + searchTerm + '?sourceType=' + sourceType + (typeof postalCode !== 'undefined' ? '&postalCode=' + postalCode : ''),
            type: 'get',
            contentType: 'application/json',
            success: function (data) {
                // Create the result for the autocomplete plugin
                CANADA_POST.results[searchTerm] = $.map(data, function (item) {
                    return {
                        id: item.id,
                        label: item.civicAddress,
                        civicAddress: item.line1,
                        apartment: item.apartment,
                        city: item.city,
                        province: item.province,
                        description: item.description,
                        postalCode: item.postalCode,
                        groupOfAddresses: item.groupOfAddresses
                    }
                });
                CANADA_POST.showResults(input, searchTerm);
            },
            error: function (jqXHR, status, error) {
                if (!redirectIfConflict(jqXHR)) {
                    console.warn("Error while trying to get Canada Post addresses, error");
                }
            }
        });
    },

    callSearchAddressForGroup: function (input, ui) {
        var groupId = ui.item.id;
        var sourceType = input.data('cp-source-type');
        $.ajax({
            url: canadaPostAjaxUrl + '/search/group/' + encodeURI(groupId) + '?sourceType=' + sourceType,
            type: 'get',
            contentType: 'application/json',
            success: function (data) {
                // Create the result for the autocomplete plugin
                CANADA_POST.results[groupId] = $.map(data, function (item) {
                    return {
                        id: item.id,
                        label: item.civicAddress,
                        civicAddress: item.line1,
                        apartment: item.apartment,
                        city: item.city,
                        province: item.province,
                        description: item.description,
                        postalCode: item.postalCode,
                        groupOfAddresses: item.groupOfAddresses
                    }
                })
                CANADA_POST.showResults(input, groupId);
            },
            error: function (jqXHR, status, error) {
                if (!redirectIfConflict(jqXHR)) {
                    console.warn("Error while trying to get Canada Post addresses, error");
                }
            }
        });
    },

    callRetrieveCanadaPostApi: function (input, ui) {
        var addressId = ui.item.id;
        var sourceType = input.data("cp-source-type");
        $.ajax({
            url: canadaPostAjaxUrl + "/retrieve/" + encodeURI(addressId) + '?sourceType=' + sourceType,
            type: 'get',
            contentType: 'application/json',
            success: function (data) {
                if (data.length > 0) {
                    var item = data[0];
                    CANADA_POST.updateForm(input, item.line1, item.apartment, item.city, item.province, item.postalCode);
                }
            },
            error: function (jqXHR) {
                if (!redirectIfConflict(jqXHR)) {
                    // fallback on data coming from previous 'find' instead of 'retrieve'
                    CANADA_POST.updateForm(input, ui.item.civicAddress, ui.item.apartment, ui.item.city, ui.item.province, ui.item.postalCode);
                    console.warn("Error while trying to retrieve Canada Post addresses");
                }
            }
        });
    },

    bind: function (html) {
        // Init the autocomplete search on keyup on address line 1 if postalCode is not disabled
        html.find(CANADA_POST.addressSelector).keyup(debounce(function (event) {
            if(event.originalEvent.code !== 'ArrowDown' && event.originalEvent.code !== 'ArrowUp' && event.originalEvent.code !== 'Enter'){
                CANADA_POST.initCompleteSearch(this);
            }
        }, 300));

        var postalCodeInput = html.find(CANADA_POST.postalCodeSelector);

        // On focus postal code input we show the alert message to prevent the user
        postalCodeInput.on('focus', function () {
            $(this).prev('[id^=postalCodeChangeMessage]').removeClass("hide");
        });

        // If the user changes the postal code we have to clear address line 1 and reset the autocomplete address search for the new postal code
        postalCodeInput.on('change', function () {
            var newPostalCode = $(this).val().toUpperCase();
            var inputAddress = $(CANADA_POST.addressSelector);
            if (newPostalCode != inputAddress.data("postal-code")) {
                inputAddress.val("");
                inputAddress.data("postal-code", newPostalCode);
                inputAddress.data("active", false);
            }
        });
    },

    //****************************************************************
    // Util
    //****************************************************************
    formatPostalCode: function (postalCode) {
        return postalCode.indexOf(" ") == 3 ? postalCode : postalCode.substr(0, 3) + " " + postalCode.substr(3);
    },

    updateForm: function (input, address, apartment, city, province, postalCode) {
        var formattedPostalCode = CANADA_POST.formatPostalCode(postalCode);
        $(CANADA_POST.addressSelector).data("postal-code", formattedPostalCode);
        var formAddress = input.closest(".canada-post-form");
        formAddress.find("input[id*='addressLine1']").val(address).trigger("input");
        formAddress.find("input[id*='city']").val(city).trigger("input");
        formAddress.find("input[id*='postalCode']").val(formattedPostalCode).trigger("input");
        formAddress.find(".input-fake[id*='postalCode']").html(formattedPostalCode).trigger("input");
        formAddress.find("input[id*='addressLine2']").val(apartment).trigger("input");
        formAddress.find("#contactDetails-province-hidden").val(province);
        let $provinceFullName = $('#province-contact input[value="' + province + '"]').prev("p").text();
        formAddress.find("#province-contact > .select >p").text($provinceFullName);
        addPlaceholderToSelect($('#province-contact > p'), getTraduction(traductionEnum.PROVINCE_PLACEHOLDER));
        $('#addressLine1').trigger('blur');
    }
};

$(() => {
    CANADA_POST.bind($('html'));
});